import { lazy } from 'react';

export const RewardRemoveForm = lazy(() => import('./RewardRemoveForm'));
